<template>
<b-card>
    <b-card-body>
    
        <h4>CFO Review</h4>

        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <b-table-simple id="fundingStrs" hover small caption-top responsive>
                        <b-thead>
                            <b-tr>
                                <b-th style="width: 6rem">Percent</b-th>
                                <b-th>Fund</b-th>
                                <b-th>Fin Dept ID</b-th>
                                <b-th>Approp ID</b-th>
                                <b-th>SW Cost</b-th>
                                <b-th>Sub Acct</b-th>
                                <b-th>Agcy Cost 1</b-th>
                                <b-th>Agcy Cost 2</b-th>
                                <b-th>Project</b-th>
                                <b-th>Activity</b-th>
                                <b-th style="width: 10rem">Source</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in funding" :key="index">
                                <b-td><b-form-input v-model="item.fundingPercent" aria-label="Percent"
                                    :class="{'is-invalid':$v.funding.$each[index].fundingPercent.$invalid, 
                                        'is-valid':!$v.funding.$each[index].fundingPercent.$invalid}" /></b-td>
                                <b-td><b-form-input v-model="item.fundId" aria-label="Fund ID"
                                    :class="{'is-invalid':$v.funding.$each[index].fundId.$invalid, 
                                        'is-valid':!$v.funding.$each[index].fundId.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.divisionId" aria-label="Fin Dept ID"
                                    :class="{'is-invalid':$v.funding.$each[index].divisionId.$invalid, 
                                        'is-valid':!$v.funding.$each[index].divisionId.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.appropriationId" aria-label="Approp ID"
                                    :class="{'is-invalid':$v.funding.$each[index].appropriationId.$invalid, 
                                        'is-valid':!$v.funding.$each[index].appropriationId.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.swCost" aria-label="SW Cost"/></b-td>
                                <b-td><b-form-input v-model="item.subAccount" aria-label="Sub Account"/></b-td>
                                <b-td><b-form-input v-model="item.agcyCost1" aria-label="Agcy Cost 1"/></b-td>
                                <b-td><b-form-input v-model="item.agcyCost2" aria-label="Agcy Cost 2"/></b-td>
                                <b-td><b-form-input v-model="item.project" aria-label="Project" maxlength="15" @keyup="maxLengthAlert"
                                    :class="{'is-invalid':$v.funding.$each[index].project.$invalid, 
                                        'is-valid':!$v.funding.$each[index].project.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.activity" aria-label="Activity"
                                    :class="{'is-invalid':$v.funding.$each[index].activity.$invalid, 
                                        'is-valid':!$v.funding.$each[index].activity.$invalid}" /></b-td>
                                <b-td><b-form-select v-model="item.sourceType" aria-label="Source Type" 
                                    :options="sourceTypeOptions"
                                    :class="{'is-invalid':$v.funding.$each[index].sourceType.$invalid, 
                                        'is-valid':!$v.funding.$each[index].sourceType.$invalid}"/></b-td>
                            </b-tr>
                            <b-tr>
                              <b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td>
                              <b-td><span v-if="displayWarning" :class="{'text-danger': displayWarning}">Maximum of {{ projectMaxLength }} characters reached.</span></b-td>
                              <b-td></b-td><b-td></b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <b-button type="button" variant="outline-primary" size="sm"
                        @click="addFundingStringRow()">
                        Add additional funding string
                    </b-button>
                </b-col>
            </b-row>






                    <div>
              <b-button type="submit" variant="primary">Submit</b-button>

            </div>
        </b-form>
    </b-card-body>
</b-card>

</template>

<script>
import axios from "axios"
import _ from "lodash"
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf, ref, minValue, maxValue } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
const terms = ['TBD', 'tbd']
const tbdValidator = (value) => !terms.some(el => value && value.indexOf(el) > -1)

export default {
    components: {
    },

    
    mixins: [
       commonOptions
    ],

    props: {
        request: Object
    },

    data() {
        return {
            funding: this.request.funding,
            comments: null,
            defaultFunding: {
                id: null, 
                fundingPercent: null, 
                fundId: '',
                divisionId: '',
                appropriationId: '',
                swCost: '',
                subAccount: '',
                agcyCost1: '',
                agcyCost2: '',
                project: '',
                activity: '',
                sourceType: ''                    
            },

            projectMaxLength: 15,
            displayWarning: false,
        }
    },

    validations: {
        comments: {maxLength: maxLength(4000) },
        funding: {
            required,
            minLength: minLength(1),
            $each: {
                fundingPercent: {
                    required,
                    numeric
                },
                fundId: {
                    required,
                    tbdValidator
                },
                divisionId: {
                    required,
                    tbdValidator
                },
                sourceType: {
                    required: requiredIf(function(item) {
                        return item.project || item.activity
                    }),
                },
                appropriationId: {
                    required,
                    tbdValidator
                },
                project: {
                    required: requiredIf(function(item) {
                        return ((item.fundId === '3000' || item.fundId === '3001') ||
                                (item.activity || item.sourceType))
                    }),
                    tbdValidator
                },
                activity: {
                    required: requiredIf(function(item) {
                        return item.project || item.sourceType
                    }),
                    maxLength: maxLength(15),
                    tbdValidator
                }
            }
        },
     },

    computed: {
        totalFundingStringPercent() {
            return _.sumBy(this.request.funding, item => Number(item.fundingPercent)) === 100 ? "valid" : ""
        },
    },

    created() { },
    
    methods: {
        addFundingStringRow() {
            var newFunding = {... this.defaultFunding}
            this.funding.push(newFunding)
        },

        onSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/fundingReview`,
                {
                    id: this.request.id,
                    funding: this.funding
                })
                .then(response => { console.log("back ") 
                    this.showRootToast("Updated", "Your review has been recorded.", "success")
                    this.$router.push('/home')})
        },
                showRootToast(title, message, type) {
                    this.$root.$bvToast.toast(message, {
                          title: title,
                          toaster: 'b-toaster-top-center',
                          solid: true,
                          variant: type,
                          appendToast: true
                        })
             },

        maxLengthAlert(event) {
          let newValue = event.target.value;
          if (newValue.length >= this.projectMaxLength) {
            event.preventDefault()
            this.address = this.previousAddress;
            this.displayWarning = true;
          }
          else {
            this.address = newValue;
            this.previousAddress = newValue;
            this.displayWarning = false;
          }
        }
    }
}
</script>
